// app/javascript/controllers/germany_map_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.states = this.element.querySelectorAll('.state')
    this.states.forEach((state) => {
      state.addEventListener('click', this.onStateClick.bind(this))
    })
  }

  onStateClick(event) {
    const stateId = event.target.id
    // Redirect to a state-specific page or perform another action
    window.location.href = `/states/${stateId}`
  }
}
